const theme = {
  colors: {
    colorWhite: "#ffffff",
    colorBlack: "#000000",
    colorText: "#323232",
    colorPrimary: "#3393EC",
    colorActiveOptionBorder: '#007AFF',
    colorActiveOptionBg: '#DBEDFF',
    colorInactiveOptionBg: '#F1F8FF',
    colorErrorText: '#FF5B5B',
    colorInputBorder: '#DEE0E6',
    colorInactiveProgressTrack: '#F3F3F3',
    colorInputPlaceholder: '#494E57',
    colorDomain: '#848484',
    colorDomainBorder: 'rgba(0, 0, 0, 0.1)',
    colorInactivePlanBorder: '#D4DAE0',
    colorInactiveCheckBorder: '#ADADAD',
    colorInactiveTrack: '#F2F2F2',
    colorCheckoutOr: '#707070',
    colorTimeBg: '#E9F4FF',
    colorReviewBg: '#F4F4F4',
    colorReviewLabelBg: '#e9e9e9',
    colorLabelText: '#5B5B5B',
    colorPaypalBg: '#f9c456',
    colorCheckoutInputBg: '#F9F9FA',
    colorCheckoutName: '#8696A6',
    colorGuaranteeText: '#909090',
    colorInactivePlanBg: '#F2F6FA',
    colorActiveIconPlanBg: '#7AC280',
    colorInactiveIconBorder: '#9AB8D6',
    colorDedicatedOldPrice: '#FF9D9D',
    colorOldPrice: '#A7AFB1',
    colorDisclaimerText: '#818181',
    colorInactiveProgress: 'rgba(51, 147, 236, 0.15)',
    colorRewardBg: 'rgba(255, 197, 23, 0.15)',
    colorSeparator: '#dddddd',
    colorPlanSeparator: '#F0F0F0',
    colorHybridPlanBg: '#F2F9FF',
    colorChartTrialBg: '#F1F1F1',
    colorChartSkipTestBg: '#00BFA5',
    colorLineBg: '#DCDCDC',
    colorDealBg: '#FF4B3D',
    colorSelectPaymentText: '#454E57',
    colorTrialPlanText: '#899497',
    colorTrialPlanBg: '#F4FAF7',
    colorTrialPlanDiscountPrice: '#6CB99C',
    colorWelcomeAddressText: '#BBBBBB',
    colorNotSureText: '#797979',
    colorCreatePlanText: '#6C797D',
    colorFactDisclaimerText: '#CECECE',
    colorRiskLevelTitleText: '#634D00',
  },
  fontSizes: {
    font6: '6px',
    font8: '8px',
    font9: '9px',
    font10: '10px',
    font11: '11px',
    font12: '12px',
    font13: '13px',
    font14: '14px',
    font15: '15px',
    font16: '16px',
    font18: '18px',
    font20: '20px',
    font24: '24px',
    font28: '28px',
    font32: '32px',
    font48: '48px',
  },
  fontWeights: {
    extraLight: 400,
    light: 500,
    medium: 600,
    bold: 700,
    extraBold: 800,
    black: 900
  },
  lineHeights: {
    lineHeight7: '7px',
    lineHeight11: '11px',
    lineHeight12: '12px',
    lineHeight14: '14px',
    lineHeight15: '15px',
    lineHeight16: '16px',
    lineHeight17: '17px',
    lineHeight19: '19px',
    lineHeight20: '20px',
    lineHeight21: '21px',
    lineHeight22: '22px',
    lineHeight24: '24px',
    lineHeight27: '27px',
    lineHeight28: '28px',
    lineHeight33: '33px',
    lineHeight36: '36px',
    lineHeight38: '38px',
  },
}

export default theme